<template>
    <div class="subcontainer">
        <div class="row" style="padding-bottom: 25px;"  v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
            <div class="col offset-s8 s4" style="text-align: end; ">
                <a v-on:click="addPlace()" class="waves-effect waves-light btn-large solidgreen btn" style="border-radius: 8px !important;">
                    {{$t('subplaces.add')}}
                </a>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th class="name" v-on:click="set_order('name')">
                        <span>{{$t('subplaces.name')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="number" type="text" class="validate" v-model="namesearch">
                        </div>
                    </th>
                    <th class="last_inspected" v-on:click="set_order('last_inspected')">
                        <span>{{$t('subplaces.last_inspected')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th class="next_inspection" v-on:click="set_order('next_inspection')">
                        <span>{{$t('subplaces.planned_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th class="status" v-on:click="set_order('status')">
                        <span>{{$t('subplaces.status')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s12" style="padding-right: 15px;">
                            <selector v-model="status" :items="statuses" identifier="statuses"></selector>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(placeItem, index) in listItems">
                    <tr class="content" :class="placeItem.status == 'active' ? '' : 'grayed'">
                        <td>
                            <div><a  style="cursor: pointer;" v-on:click="goToPlace(placeItem.id)">{{!!placeItem.name ? placeItem.name :  $t('places.no_name')  }}</a></div>
                        </td>
                        <td>
                            <div>{{placeItem.last_inspected * 1000 | formatDate}}</div>
                        </td>
                        <td>
                            <div>{{placeItem.next_inspection * 1000 | formatDate}}</div>
                        </td>
                        <td>
                            <div>{{placeItem.status == "active" ? $t('subplaces.status_active') : (placeItem.status == "suspended" ? $t('subplaces.status_suspended') : $t('subplaces.status_inactive'))}}</div>
                        </td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
export default {
    data: function() {
        return {
            order: 'asc',
            orderby: 'number',
            loaded: false,
            places: [],
            selectedTags: [],
            statuses: [
                { name: this.$t('subplaces.status_active'), value: 'active' },
                { name: this.$t('subplaces.status_inactive'), value: 'inactive' },
                { name: this.$t('subplaces.status_suspended'), value: 'suspended' }
            ],
            namesearch: "",
            lastInspectiondateRange: { startDate: moment().startOf('year').format(), endDate: moment().endOf('year').format() },
            nextInspectiondateRange: { startDate: moment().startOf('year').format(), endDate: moment().endOf('year').format() }
        }
    },
    props: { customer_id: Number, role: String, extended_privileges: Boolean, status: {
        type: Array,
        default: function(){
            return ['active']
        }
    } },
    watch: {
        customer_id: function(newVal, oldVal) { // watch it
            this.loaded = false;
            this.fetch_places();
        }
    },
    created() {

    },
    mounted() {
        this.fetch_places();
    },
    methods: {
        fetch_places: function() {
            axios.get('/customers/' + this.customer_id + '/places.json').then(response => {
                this.places = response.data;
                for (var i in this.places) {
                    var place = this.places[i];
                    place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
                }
                this.loaded = true;
                this.init_selectors();
            })

        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        init_selectors: function() {

        },
        goToPlace(place_id) {
            this.$router.push('/customers/'+this.customer_id+'/places/'+place_id);
        },
        addPlace() {
            this.$router.push('/customers/'+this.customer_id+'/places/new');
        }
    },
    computed: {
        listItems() {
            var that = this;
            const range = moment.range(moment(this.lastInspectiondateRange.startDate), moment(this.lastInspectiondateRange.endDate));
            const next_range = moment.range(moment(this.nextInspectiondateRange.startDate), moment(this.nextInspectiondateRange.endDate));
            return _.filter(
                _.orderBy(this.places, this.orderby, this.order),
                function(item) {
                    return (_.includes(that.status, item.status) || that.status.length == 0) && item.name.toUpperCase().indexOf(that.namesearch.toUpperCase()) >= 0
                }
            );
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

/*.maincontainer{
  margin: 33px;
}*/
thead {
    background-color: #DADADA;
    font-size: 15px;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

.subcontainer {
    margin-left: 30px;
}

.content div {
    margin-left: 15px;
}

/deep/ .vue-daterange-picker>div {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    border-radius: 5px;
    margin-bottom: 8px;
}

/deep/ .reportrange-text {
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 7px !important;
}

th span {
    padding-left: 5px;
}

a {
    color: black;
}

select {
    display: block;
}

.solidgreen {
    background-color: #00CC66;
}
.btn-large {
    border-radius: 8px;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}
.grayed {
    color: #BEBBBB !important;
}
.grayed a{
    color: #BEBBBB !important;
}
</style>